import type { ComponentPropsWithoutRef } from 'react';

import classNames from 'classnames';

import ImageProxy from '@next-image-proxy';

import { eye3 } from '@shared/assets/images/scope/errorPage';

interface EmptyWidgetProps extends ComponentPropsWithoutRef<'div'> {
  title?: string;
  description?: string;
}

const EmptyWidget = ({
  title = 'Nothing here yet',
  description = 'Currently Empty',
  className,
  ...props
}: EmptyWidgetProps) => {
  return (
    <div
      className={classNames(
        'flex flex-col text-center justify-center items-center py-10',
        className,
      )}
      {...props}
    >
      <ImageProxy src={eye3} alt="" className="w-[88px] object-cover" />
      <p className="font-semibold">{title}</p>
      <p className="text-sm text-neutral-400 pb-3">{description}</p>
    </div>
  );
};

export default EmptyWidget;
